import React from 'react';

/**
 * SpinnerOverlay — full-screen or contained loading overlay with animated spinner.
 * Props:
 *   visible   {boolean}  — show/hide
 *   message   {string}   — optional subtitle
 *   title     {string}   — optional title (default "Please wait…")
 *   contained {boolean}  — if true, positions relative to parent instead of fixed
 */
const SpinnerOverlay = ({ visible, message, title = 'Please wait…', contained = false }) => {
  if (!visible) return null;

  const posClass = contained
    ? 'absolute inset-0 rounded-2xl' :'fixed inset-0 z-[9999]';

  return (
    <div className={`${posClass} bg-[#0a1628]/75 backdrop-blur-sm flex items-center justify-center`}>
      <div className="bg-white rounded-2xl px-8 py-7 flex flex-col items-center gap-4 shadow-2xl max-w-xs w-full mx-4">
        {/* Spinner ring */}
        <div className="relative w-14 h-14">
          <div className="absolute inset-0 rounded-full border-4 border-[#0a1628]/10" />
          <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-[#ffd700] animate-spin" />
          <div className="absolute inset-2 rounded-full border-4 border-transparent border-t-[#0a1628]/30 animate-spin" style={{ animationDirection: 'reverse', animationDuration: '0.6s' }} />
        </div>
        {/* Dots */}
        <div className="flex gap-1.5">
          {[0, 1, 2]?.map(i => (
            <div
              key={i}
              className="w-2 h-2 rounded-full bg-[#ffd700] animate-bounce"
              style={{ animationDelay: `${i * 0.15}s` }}
            />
          ))}
        </div>
        <div className="text-center">
          <p className="text-[#0a1628] font-bold text-sm">{title}</p>
          {message && <p className="text-[#0a1628]/55 text-xs mt-1">{message}</p>}
        </div>
      </div>
    </div>
  );
};

export default SpinnerOverlay;
